export default __webpack_public_path__ + "static/media/remove-icon.e4fa2b52.svg";